import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'

import Flex from '../../../components/Flex'
import Box from '../../../components/Box'
import Button from '../../../components/Button'
import isIos from '../../../components/utils/isIos'

// import clock from './timer.svg'
import { responsive } from '../../../components/ThemeProvider/theme'

const CircleButton = props => (
  <Box
    width={responsive('10em', '8em')}
    // height={responsive('10em', '8em')}
    transform={responsive('', 'translateY(-35vh)')}
  >
    <Button.Icon
      bg="white"
      rounded="full"
      width="100%"
      height="auto"
      _disabled={{
        opacity: 1,
      }}
      {...props}
    />
  </Box>
)

const negative = {
  justfont: <StaticImage placeholder="tracedSVG" src="../justfont/x.png" />,
  "bonne-chance": <StaticImage placeholder="tracedSVG" src="../bonne-chance/x.png" />,
  plainlaw: <StaticImage placeholder="tracedSVG" src="../plainlaw/x.png" />,
}
const positive = {
  justfont: <StaticImage placeholder="tracedSVG" src="../justfont/o.png" />,
  "bonne-chance": <StaticImage placeholder="tracedSVG" src="../bonne-chance/o.png" />,
  plainlaw: <StaticImage placeholder="tracedSVG" src="../plainlaw/o.png" />,
}

const Controls = ({ onAnswer, disabled, path }) => {
  return (
    <Flex position="absolute" left="0" right="0" bottom={responsive(isIos ? '2em' : '3em', '1em')} justifyContent="space-around" alignItems="center">
      <CircleButton
        border="none"
        isDisabled={disabled}
        onClick={() => onAnswer(-1)}
        icon={negative[path]}
      />
      <Box width={responsive('7em', '5em')}>
        {/* <BackgroundImage ratio={1} src={clock}>
          <Box.AbsCenter top="58%" color="pink.300" fontSize={responsive('6em', '2em')} fontWeight="900">{time}</Box.AbsCenter>
        </BackgroundImage> */}
      </Box>
      <CircleButton
        border="none"
        isDisabled={disabled}
        onClick={() => onAnswer(1)}
        icon={positive[path]}
      />
    </Flex>
  )
}

export default Controls
